import React from "react";
import { Icon } from "semantic-ui-react";

const UserCommentDelete = ({ onClick }) => (
  <Icon name="window close" onClick={onClick} className="delete-comment" />
);

export default UserCommentDelete;
